import { getCampaignById, getCampaigns } from '../../services/aiRecruiterService';

const getCampaignCreatedTime = (campaign: any): number => {
  const value = campaign?.createdAt;
  if (Array.isArray(value)) {
    return new Date(
      value[0],
      (value[1] || 1) - 1,
      value[2] || 1,
      value[3] || 0,
      value[4] || 0,
      value[5] || 0,
    ).getTime();
  }
  return value ? new Date(value).getTime() : 0;
};

export const pickLatestCampaign = (campaigns: any[]): any | null => {
  if (!Array.isArray(campaigns) || campaigns.length === 0) return null;
  return [...campaigns].sort((a, b) => {
    const versionDiff = Number(b.version || 0) - Number(a.version || 0);
    if (versionDiff !== 0) return versionDiff;
    return getCampaignCreatedTime(b) - getCampaignCreatedTime(a);
  })[0];
};

export const getCampaignReusableSettings = (campaign: any): Record<string, any> => {
  if (!campaign) return {};
  return {
    ...(campaign.recruiterName != null ? { recruiterName: campaign.recruiterName } : {}),
    ...(campaign.firstMessageTemplate != null ? { firstMessageTemplate: campaign.firstMessageTemplate } : {}),
    ...(campaign.firstMessageTemplateClarify != null ? { firstMessageTemplateClarify: campaign.firstMessageTemplateClarify } : {}),
    ...(campaign.approvalMessageTemplate != null ? { approvalMessageTemplate: campaign.approvalMessageTemplate } : {}),
    ...(campaign.rejectionMessageTemplate != null ? { rejectionMessageTemplate: campaign.rejectionMessageTemplate } : {}),
    ...(campaign.responseDelayMin != null ? { responseDelayMin: campaign.responseDelayMin } : {}),
    ...(campaign.responseDelayMax != null ? { responseDelayMax: campaign.responseDelayMax } : {}),
    ...(campaign.attempts != null ? { attempts: campaign.attempts } : {}),
    ...(campaign.maxActiveDialogs != null ? { maxActiveDialogs: campaign.maxActiveDialogs } : {}),
    ...(campaign.dailyLimit != null ? { dailyLimit: campaign.dailyLimit } : {}),
    ...(campaign.pauseBetweenAttemptsHours != null ? { pauseBetweenAttemptsHours: campaign.pauseBetweenAttemptsHours } : {}),
    ...(campaign.contactWindowStart != null ? { contactWindowStart: campaign.contactWindowStart } : {}),
    ...(campaign.contactWindowEnd != null ? { contactWindowEnd: campaign.contactWindowEnd } : {}),
    ...(campaign.accountSettings != null ? { accountSettings: campaign.accountSettings } : {}),
  };
};

export const loadLatestCampaignReusableSettings = async (positionId: string | number | null | undefined): Promise<Record<string, any>> => {
  if (positionId == null || positionId === '') return {};

  const campaignsResponse = await getCampaigns({ positionId: Number(positionId), size: 1000 });
  const latestCampaign = pickLatestCampaign(campaignsResponse?.content);
  if (!latestCampaign?.id) {
    return {};
  }

  try {
    const fullCampaign = await getCampaignById(latestCampaign.id);
    return getCampaignReusableSettings(fullCampaign || latestCampaign);
  } catch (error) {
    console.warn('Failed to load full latest campaign settings, using list data', error);
    return getCampaignReusableSettings(latestCampaign);
  }
};
